export enum Autoupdateenum {
    Emergency = 'Emergency',
    List = 'List',
    FlightStatus = 'FlightStatus',
    FileUpload = 'FileUpload',
    VitalRequested = 'VitalRequested',
    MedicalKit = 'MedicalKit',
    VoiceCall = "VoiceCall",
    VoiceCallEnded = "VoiceCallEnded"
  }